import styled from 'styled-components';

export const InputWrapV2 = styled.div`
  padding: 0;
  margin: 0;
  display: block;
  font-size: 0.875rem;
  color: ${(p) => p.theme.dark_gray};
  input {
    &:focus, &:focus-within {
      box-shadow: 0 1px color-mix(in oklab,#1D1B26calc(0*10%),#0000);
      outline: 2px solid #1D1B26;
      outline-offset: 2px;
      isolation: isolate;
    }
    :-moz-placeholder,
    ::-moz-placeholder,
    :-ms-input-placeholder,
    ::-webkit-input-placeholder {
      color: ${(p) => p.theme.dark_gray};
      font-style: italic;
    }
  }
  input,
  input[type=text],
  input[type=email],
  input[type=password],
  input[type=search] {
    font-family: ${(p) => p.theme.bodyFont};
    color: ${(p) => p.theme.blackish};
    padding: 5px 8px;
    line-height: 33px;
    height: 2.5rem;
    box-sizing: border-box;
    border: 1px solid ${(p) => p.theme.dark_grey};
    border-radius: 3.5px;
    -webkit-appearance: none;
    -moz-appearance: none;
    font-size: 14px;
    appearance: none;
    width: 100%;
  }
  input[type=text]:disabled,
  input[type=password]:disabled,
  input[type=search]:disabled,
  input[type=text]:read-only,
  input[type=password]:read-only,
  input[type=search]:read-only {
    background: ${(p) => p.theme.very_light_gray};
    color: ${(p) => p.theme.very_dark_gray};
    border-color: transparent;
  }
  input.error {
    border: 1px solid ${(p) => p.theme.Macmillan_red} !important;
    background: ${(p) => p.theme.very_light_red} !important;
  }
  .errorText {
    margin-top: 6px;
    font-size: 0.875rem;
    color: ${(p) => p.theme.Macmillan_red};
  }
`;
